const initRaffleWinner = {
  raffleWinners: [],
  currentPage: 1,
  totalPage: 1,
  limitPage: 10,
  lengthPage: 1,
  searchValue: "",
  isFormLoading: false,
  filterCityPage: "",
};

export const raffleWinnerReducer = (state = initRaffleWinner, action: any) => {
  if (action.type === "SET_RAFFLE_WINNER") {
    return {
      ...state,
      raffleWinners: action.value,
    };
  }
  if (action.type === "SET_RAFFLE_WINNER_CURRENT_PAGE") {
    return {
      ...state,
      currentPage: action.currentPage,
    };
  }
  if (action.type === "SET_RAFFLE_WINNER_PAGE") {
    return {
      ...state,
      totalPage: action.totalPage,
      limitPage: action.limitPage,
      lengthPage: action.lengthPage,
    };
  }
  if (action.type === "SET_SEARCH_RAFFLE_WINNER") {
    return {
      ...state,
      searchValue: action.searchValue,
    };
  }
  if (action.type === "SET_FORM_LOADING") {
    return {
      ...state,
      isFormLoading: action.value,
    };
  }
  if (action.type === "SET_RAFFLE_WINNER_FILTER_PAGE") {
    return {
      ...state,
      filterCityPage: action.filterCityPage,
    };
  }
  return state;
};
